/*
 * @Author: niuqingxia
 * @Date: 2024-12-20 10:03:53
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Mo 01:51:02
 滚动表格
 */

<template>
  <div class="scroll-table" :style="{width: config.chartWidth+'px',height:config.chartHeight+'px'}">
    <div class="scroll-table-wrapper">
      <img v-if="borderImgUrl" class="scroll-table-border" :src="borderImgUrl" alt=""
           :style="{
             display:'inline-block',
             width:'100%',
             height: '100%'
           }">
      <div class="scroll-table-title" :style="{
        width:'100%',
        textAlign: style.titleStyle.align,
        fontSize: style.titleStyle.fontSize + 'px',
        color: style.titleStyle.color,}">
        {{ (activatedLabel+' ' || '') + config.chartTitle }}
        <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
          <div slot="content" v-html="indicatorDescription"></div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
    </div>

    <!-- 表头 -->
    <div class="scroll-container">
      <div class=" drag-cancel">
        <el-table
          :key="uniqueKey"
          :data="tableData"
          class="table-header"
          border
          :header-row-style="getHeaderRowStyle"
          @header-dragend="handleHeaderDrag">
          <el-table-column
            v-for="(key,idx) in colKeyList"
            :key="idx"
            :prop="key"
            :width="config.chartSet.chartStyle[key]+'px'">
            <template slot="header">
              <span :style="{fontSize: fontSize +'px'}">{{ tableHeader[idx] }} </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 表格内容 -->
      <vue-seamless-scroll
        v-if="config.chartSet.chartStyle.isScroll && tableData.length > 1"
        ref="seamlessScroll"
        :data="tableData"
        class="scroll-list"
        :class-option="tableOption">
        <el-table
          class="scroll-table"
          :class="isStripe ? '':'row-space'"
          :data="tableData"
          border
          :row-style="getRowStyle">
          <el-table-column
            v-for="(key,idx) in colKeyList"
            :key="idx"
            :prop="key"
            :width="config.chartSet.chartStyle[key]+'px'">
            <template slot-scope="scope">
              <span :style="{fontSize: fontSize +'px'}"> {{ scope.row[key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </vue-seamless-scroll>
      <div v-else class="scroll-list">
        <el-table
          class="scroll-table"
          :class="isStripe ? '':'row-space'"
          :data="tableData"
          border
          :row-style="getRowStyle">
          <el-table-column
            v-for="(key,idx) in colKeyList"
            :key="idx"
            :prop="key"
            :width="config.chartSet.chartStyle[key]+'px'">
            <template slot-scope="scope">
              <span :style="{fontSize: fontSize +'px'}"> {{ scope.row[key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { imgURLtoBase64 } from '@/utils/common'
import { COLOR_LIST } from '@/utils/defaultColorData'
import { relateBus } from '@/eventBus'
import ChartMixin from '../mixin'
export default {
  name: 'ScrollTable',
  components: {
    vueSeamlessScroll,
  },
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    showData: {
      type: Array,
    },
  },
  data () {
    return {
      timer: null,
      activatedLabel: this.config.chartViewData.chartData[0]?.labelName || '',
      uniqueKey: 'xxxx',
      borderImgUrl: '',
      themeColor: COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value[0],
    }
  },
  computed: {
    // 是否多数据源
    isMultipleChartData () {
      return !!this.config.chartViewData.chartData[0]?.labelName
    },
    dataIndex () {
      if (this.isMultipleChartData) {
        const i = this.config.chartViewData.chartData.findIndex(bar => bar.labelName === this.activatedLabel)
        return i === -1 ? 0 : i
      } else {
        return 0
      }
    },
    isStripe () {
      return this.config.chartSet.chartStyle.stripe
    },
    fontSize () {
      return this.config.chartSet.chartStyle.fontSize
    },
    // 表格数据
    chartData () {
      if (this.isMultipleChartData) {
        return this.config.chartViewData.chartData[this.dataIndex].realChartData
      } else {
        return this.config.chartViewData.chartData
      }
    },
    colKeyList () {
      const list = []
      const colKeyList = Object.keys(this.chartData[0])
      // 遍历所有列
      colKeyList.forEach(key => {
        // 排除空数据
        if (!this.tableData?.every(row => (row[key] === '' || row[key] === undefined))) {
          list.push(key)
        }
      })
      return list
    },
    tableHeader () {
      return this.colKeyList.map(key => this.chartData[0][key])
    },
    tableData () {
      return Array.isArray(this.chartData) ? this.chartData.slice(1) : []
    },
    tableOption () {
      return {
        step: this.config.chartSet.chartStyle.step, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: this.config.chartSet.chartStyle.hoverStop, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    style () {
      return this.config.chartSet
    },
    borderStyle () {
      return this.config.chartSet.borderStyle.borderTemplate
    },
  },
  watch: {
    // 全局样式监听
    'globalConfig.chartColors': {
      handler () {
        // 主题颜色修改
        this.themeColor = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value[0]
        this.$nextTick(() => {
          this.$refs.seamlessScroll && this.$refs.seamlessScroll.reset()
        })
      },
      deep: true,
    },
    // 配置项变更
    config: {
      handler: function () {
        setTimeout(() => {
          this.$refs.seamlessScroll && this.$refs.seamlessScroll.reset()
          this.uniqueKey = Math.random()
        }, 120)
      },
      deep: true,
    },
    async borderStyle (val) {
      if (val) {
        this.borderImgUrl = await imgURLtoBase64(val)
      } else {
        this.borderImgUrl = ''
      }
    },
  },
  async created () {
    if (this.borderStyle) {
      this.borderImgUrl = await imgURLtoBase64(this.borderStyle)
    }
    if (!this.style.chartStyle?.carouselDelay) { this.$set(this.config.chartSet.chartStyle, 'carouselDelay', 3) }
  },
  mounted () {
    relateBus.$on('activeChange', (mapAddSn, data) => {
      if (this.isMultipleChartData && data.name && this.config.chartSet.chartStyle.linkMap === mapAddSn) {
        this.activatedLabel = data.name
        clearTimeout(this.timer)
        this.timer = null
        this.timer = setTimeout(() => {
          this.$refs.seamlessScroll && this.$refs.seamlessScroll.reset()
        }, 60)
      }
    })
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {

    handleHeaderDrag (newWidth, oldWidth, column, event) {
      this.$set(this.config.chartSet.chartStyle, column.property, newWidth)
      this.$refs.seamlessScroll.reset()
    },

    hexToRgba (hex, opacity) {
      return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    },
    // 表头样式
    getHeaderRowStyle ({ row, rowIndex }) {
      return {
        backgroundColor: this.hexToRgba(this.themeColor, 0.5),
      }
    },
    // 行样式
    getRowStyle ({ row, rowIndex }) {
      const rgbaColor1 = this.hexToRgba(this.themeColor, 0.4)
      const rgbaColor2 = this.hexToRgba(this.themeColor, 0.2)
      return {
        backgroundColor: this.isStripe
          ? rowIndex % 2 ? rgbaColor1 : rgbaColor2
          : rgbaColor1,
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.scroll-table{
  display: flex;
  flex-direction: column;
  &-wrapper {
    position: relative;
    width:100%;
    margin-bottom: 10px;
  }
  &-border {
    position: absolute;
    top: 0;
    height: 100%;
    z-index: -1;
  }
  &-title {
    padding:7px 30px;
  }
  .scroll-container {
    flex: 1;
    height: 100%;
    overflow: hidden;
    // 表头
    :deep(.table-header){
      overflow: inherit;
      background-color: transparent;
      border: none;
      &:after,&:before{
        content: none
      }
      .el-table__header-wrapper{
        tr{
          background-color: transparent;
          :first-child{
            .cell{
              padding: 0 10px !important;
            }
          }
        }
        .el-table__cell{
          background-color: inherit !important;
          border-bottom: none;
          border-top: none;
          color: #fff;
          padding: 4px 0;
          border-right: 1px solid rgba(255,255,255,.2);
          height: inherit;
        }
      }
      .el-table__body-wrapper{
        display: none;
      }
      .el-table__column-resize-proxy{
        height: 10000px;
      }
    }
    // 表格内容
    :deep(.scroll-list) {
      overflow: hidden;
      border: none;
      .scroll-table{
        background-color: transparent;
        border: none;
        &.row-space{
          .el-table__body{
            border-spacing: 0 10px;
            margin-top: -10px;
          }
        }
        &:after,&:before{
          content: none
        }
      }
      .el-table__header-wrapper{
        display: none;
      }
      .el-table__body-wrapper{
        .el-table__row{
          background-color: transparent;
          &:hover{
            .el-table__cell{
              background-color: inherit;
            }
          }
          .el-table__cell{
            border: none;
            color: #fff;
            padding: 4px 0;
            &:first-child{
              .cell{
                padding-left: 10px !important;
              }
            }
            .cell{
              height: 100%;
            }
          }
        }
      }
    }
  }
}

</style>
